import { AppKeyEnum, PlatformEnum } from '@/constants/enum';
import { cmsApiCaller } from '@/redux/query';
import { Banner, BlockStack } from '@shopify/polaris';
import { useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'hide_holiday_banner';

export default function HolidayBanner() {
  const [isHide, setIsHide] = useState<Record<string, boolean>>(JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'));

  useEffect(() => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(isHide));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(isHide)]);

  const { data } = cmsApiCaller.useGetHolidayBannerQuery({
    appKey: AppKeyEnum.Estimated,
    platform: PlatformEnum.Shopline,
    languageCode: 'en',
  });

  const banners = useMemo(() => {
    const banners = data?.data || [];
    return banners
      .map((banner) => {
        if (!banner.isActive) return undefined;
        const { bannerTranslations, ...rest } = banner;

        const activeTranslations = bannerTranslations.filter((t) => t.isActive);
        const translation = activeTranslations.find((t) => t.languageCode === 'en') || activeTranslations[0];

        if (!translation) return undefined;

        return {
          ...rest,
          title: translation.title,
          description: translation.description,
        };
      })
      .filter((banner) => !!banner)
      .sort((a, b) => a?.priority - b?.priority);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(data)]);

  const handleHideBanner = (key: string) => {
    setIsHide((prev) => ({ ...prev, [key]: true }));
  };

  return (
    <BlockStack>
      {banners.map((banner) =>
        !isHide[banner?.bannerKey || ''] ? (
          <Banner
            key={banner?.id}
            title={banner?.title}
            onDismiss={banner?.isShowDismissBtn ? () => handleHideBanner(banner?.bannerKey || '') : undefined}
            tone={banner?.tone}
          >
            <BlockStack>
              {banner?.description.map((description) => (
                <div key={description} dangerouslySetInnerHTML={{ __html: description }} />
              ))}
            </BlockStack>
          </Banner>
        ) : null,
      )}
    </BlockStack>
  );
}
